module.exports = __webpack_public_path__ + "img/3a1e8a9c68792d26a6697c43ba114ab.d0289dc0.png";